import { tr as __tr, useLocale as __useLocale, direction as __direction, localizedField as __localizedField } from "../../i18n/runtime";
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useAuth } from '../../context/AuthContext';
const field = 'block w-full border rounded p-2 mt-1';
export default function CommerceSettings({
  kind
}) {
  __useLocale();
  const {
    token
  } = useAuth();
  const [rows, setRows] = useState([]);
  const [currencies, setCurrencies] = useState([]);
  const [form, setForm] = useState(null);
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);
  const [reload, setReload] = useState(0);
  const headers = {
    Authorization: `Bearer ${token}`
  };
  useEffect(() => {
    const c = new AbortController();
    Promise.all([axios.get(`/api/commerce-config.php?kind=${kind}&admin=1`, {
      headers: {
        Authorization: `Bearer ${token}`
      },
      signal: c.signal
    }), axios.get('/api/commerce-config.php?kind=currencies&admin=1', {
      headers: {
        Authorization: `Bearer ${token}`
      },
      signal: c.signal
    })]).then(([a, b]) => {
      setRows(a.data);
      setCurrencies(b.data);
    }).catch(e => {
      if (!c.signal.aborted) setError(e.response?.data?.message || "تعذر تحميل الإعدادات");
    });
    return () => c.abort();
  }, [kind, token, reload]);
  const change = (k, v) => setForm(p => ({
    ...p,
    [k]: v
  }));
  const text = (k, label, type = 'text') => <label>{__tr(label)}<input type={type} className={field} value={form[k] || ''} onChange={e => change(k, e.target.value)} /></label>;
  const isCurrency = kind === 'currencies';
  return <div className="space-y-4" dir={__direction()}><h2 className="text-xl font-bold">{__tr(isCurrency ? "العملات" : "بوابات الدفع")}</h2>{__tr(error && <p role="alert" className="text-red-700">{__tr(error)}</p>)}
 <button className="bg-[#6B5B95] text-white rounded px-4 py-2" onClick={() => setForm(isCurrency ? {
      code: '',
      name: '',
      symbol: '',
      is_active: true,
      is_default: false
    } : {
      name: '',
      provider: 'bank_transfer',
      enabled: false,
      mode: 'sandbox',
      client_id: '',
      client_secret: '',
      instructions: '',
      currencies: ['USD'],
      site_url: window.location.origin
    })}>{__tr("إضافة ")}{__tr(isCurrency ? "عملة" : "بوابة دفع")}</button>
 {__tr(!isCurrency && <p className="text-sm">{__tr("PayPal يدعم الربط الآلي. يمكنك إضافة وسائل تحويل بنكي أو دفع في المكتب بأسماء وتعليمات مستقلة؛ تأكيد سدادها يدوي. لن يظهر أي سر محفوظ هنا.")}</p>)}
 {__tr(isCurrency && <p className="text-sm">{__tr("رمز العملة ثابت بعد الإنشاء لحماية الحركات السابقة. يمكن تعديل الاسم والرمز والتفعيل. الأسعار تُسجل بعملة الخدمة دون تحويل تلقائي.")}</p>)}
 {__tr(form && <form onSubmit={async e => {
      e.preventDefault();
      setBusy(true);
      setError('');
      try {
        await axios.post(`/api/commerce-config.php?kind=${kind}`, form, {
          headers
        });
        setForm(null);
        setReload(n => n + 1);
      } catch (e) {
        setError(e.response?.data?.message || "تعذر الحفظ");
      } finally {
        setBusy(false);
      }
    }} className="border rounded p-4"><fieldset disabled={busy} className="space-y-4"><div className="grid md:grid-cols-2 gap-4">
 {__tr(text('name', "الاسم"))}{text('name_en', __tr("الاسم بالإنجليزية"))}{__tr(isCurrency ? <><label>{__tr("رمز العملة (مثل USD)")}<input required maxLength={3} disabled={form.editing} className={field} value={form.code} onChange={e => change('code', e.target.value.toUpperCase())} /></label>{__tr(text('symbol', "رمز العرض"))}<label><input type="checkbox" checked={!!form.is_active} onChange={e => change('is_active', e.target.checked)} />{__tr(" مفعلة")}</label><label><input type="checkbox" checked={!!form.is_default} onChange={e => change('is_default', e.target.checked)} />{__tr(" العملة الافتراضية")}</label></> : <>
 <label>{__tr("نوع الربط")}<select disabled={!!form.id} className={field} value={form.provider} onChange={e => setForm({
                ...form,
                provider: e.target.value,
                currencies: ['USD']
              })}><option value="paypal">{__tr("PayPal — آلي")}</option><option value="bank_transfer">{__tr("تحويل بنكي — يدوي")}</option><option value="cash">{__tr("دفع في المكتب — يدوي")}</option></select></label>
 <label><input type="checkbox" checked={!!form.enabled} onChange={e => change('enabled', e.target.checked)} />{__tr(" تفعيل للشراء")}</label>
 {__tr(form.provider === 'paypal' && <><label>{__tr("الوضع")}<select className={field} value={form.mode} onChange={e => change('mode', e.target.value)}><option value="sandbox">{__tr("تجريبي Sandbox")}</option><option value="live">{__tr("فعلي Live")}</option></select></label>{__tr(text('client_id', 'Client ID'))}{__tr(text('client_secret', form.has_secret ? "Client Secret — اتركه فارغًا للاحتفاظ بالمحفوظ" : 'Client Secret', 'password'))}{__tr(text('site_url', "رابط الموقع للعودة بعد الدفع"))}</>)}
 {text('instructions_en', __tr("تعليمات الدفع بالإنجليزية"))}<label className="md:col-span-2">{__tr("تعليمات الدفع")}<textarea maxLength={3000} className={field} value={form.instructions} onChange={e => change('instructions', e.target.value)} /></label><div className="md:col-span-2">{__tr("العملات المقبولة")}<div className="flex flex-wrap gap-4 mt-2">{__tr(currencies.map(c => <label key={c.code}><input type="checkbox" checked={form.currencies.includes(c.code)} onChange={e => change('currencies', e.target.checked ? [...form.currencies, c.code] : form.currencies.filter(v => v !== c.code))} /> {__tr(c.code)}</label>))}</div></div></>)}
 </div><button className="bg-[#6B5B95] text-white px-4 py-2 rounded">{__tr(busy ? "جارٍ الحفظ…" : "حفظ")}</button> <button type="button" onClick={() => setForm(null)}>{__tr("إغلاق")}</button></fieldset></form>)}
 <div className="space-y-2">{__tr(rows.map(r => <div key={r.code || r.id} className="flex flex-wrap justify-between items-center border rounded p-3 gap-3"><div><strong>{__tr(__localizedField(r, "name"))}</strong> — {__tr(r.code || r.provider)} <span>{__tr(Number(isCurrency ? r.is_active : r.enabled) ? "مفعلة" : "معطلة")}</span>{__tr(!!Number(r.is_default) && " — افتراضية")}{__tr(r.provider === 'paypal' && ` — ${r.mode}`)}</div><button className="text-purple-700" onClick={() => setForm({
          ...r,
          editing: true,
          is_active: !!Number(r.is_active),
          is_default: !!Number(r.is_default),
          enabled: !!Number(r.enabled),
          client_secret: ''
        })}>{__tr("تعديل")}</button></div>))}</div></div>;
}
